import { Injectable } from '@angular/core';
import { NotificationTemplateControllerService } from '@osos/shared/api';
import { ManagedHttpContext, ResolveTokensModel } from '@osos/shared/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// TODO: Use this data-service to wrap both notification & notification template contoller services.

@Injectable()
export class NotificationDataService extends NotificationTemplateControllerService {
  resolveTemplateTokens(template: ResolveTokensModel): Observable<string[]> {
    return this.resolveTokens({
      body: { ...template },
      context: new ManagedHttpContext({ bypassPublicMiddleware: true }),
    }).pipe(map((res) => res.map((val) => val.name)));
  }
}
